import gateway from '@interceptors/gateway.interceptor';

class RouteService {

     public findRoutesByAccomodationId = async (qrCodeId: string) => {
        try {
            const url = `/no-auth/routes/get-all-routes-by-accomodation-id/${qrCodeId}`;
            const response = await gateway.get(url);
            return response;
        } catch (error: any) {
            if (error.response) {
                console.warn("Status:", error.response.status);
                console.warn("Data:", JSON.stringify(error.response.data, null, 2));
                throw new Error(error.response.data.error);
            } else {
                console.warn("Errore generico:", error.message);
            }
        }
    };    

}
const routeService = new RouteService()
export default routeService;